import { render, staticRenderFns } from "./Spendings.vue?vue&type=template&id=b02d8950&scoped=true&"
import script from "./Spendings.vue?vue&type=script&lang=js&"
export * from "./Spendings.vue?vue&type=script&lang=js&"
import style0 from "./Spendings.vue?vue&type=style&index=0&id=b02d8950&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02d8950",
  null
  
)

export default component.exports